import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import { FILTER_GENDER, FILTERS_MODAL } from 'dpl/constants/query_params';
import { GENDERS } from 'dpl/shared/constants/breeder_app';
import useAnalyticsContext from 'dpl/puppy_search_results/hooks/useAnalyticsContext';

import FilterPill from './FilterPill';

export default function GenderFilterButtons() {
  const queryParams = useSelector(state => state.queryParams);
  const { genderOptions } = useSelector(({ server }) => server);
  const dispatch = useDispatch();
  const { sendBreedSearchedAnalytics } = useAnalyticsContext();

  useEffect(() => {
    if (!queryParams[FILTER_GENDER] || queryParams[FILTERS_MODAL] === 'true') {
      return;
    }
    sendBreedSearchedAnalytics();
  }, [queryParams[FILTER_GENDER]]);

  function handleGenderFilterClick(value) {
    const paramValue = queryParams[FILTER_GENDER];
    const genderFilterValues = genderOptions.map(go => go.value);
    const oppositeValue = genderFilterValues.find(v => v !== value) || '';

    if (paramValue === 'any') {
      dispatch(pushParams({ [FILTER_GENDER]: oppositeValue }, { hash: true }));
    } else if (paramValue === value) {
      dispatch(resetParams(FILTER_GENDER, { hash: true }));
    } else if (paramValue === oppositeValue) {
      dispatch(pushParams({ [FILTER_GENDER]: 'any' }, { hash: true }));
    } else {
      dispatch(pushParams({ [FILTER_GENDER]: value }, { hash: true }));
    }
  }

  function isSelected(opt) {
    const paramValue = queryParams[FILTER_GENDER];
    if (!paramValue) {
      return false;
    }
    if (paramValue === 'any' || opt === paramValue) {
      return true;
    }
    return false;
  }

  return (
    <>
      <FilterPill
        label="Female"
        onClick={() => handleGenderFilterClick(GENDERS.FEMALE)}
        isSelected={isSelected(GENDERS.FEMALE)}
        prefixIconName="fetch-female"
      />
      <FilterPill
        label="Male"
        onClick={() => handleGenderFilterClick(GENDERS.MALE)}
        isSelected={isSelected(GENDERS.MALE)}
        prefixIconName="fetch-male"
      />
    </>
  );
}
